export const BASE_URL =
  // "http://192.168.0.25:8000/api/";
  // "https://dev-admin.khyathilogistics.com/";
  //  "https://dev-script.khyathilogistics.com/api/";
  // 'https://uat-script.khyathilogistics.com/api/';
  'https://backend.khyathilogistics.com/api/';

export const URLS = {
  LOGIN: "admin/login/",
  LOGOUT: "admin/logout/",
  FORGET_PASSWORD: "admin/forget-password/",
  RESET_PASSWORD: "admin/reset-password/",
  OTP_VERIFY: "admin/admin/reset/verify-otp/",
  ADMIN_LIST: "admin/create-list/",
  ADMIN_VIEW: "admin/create-list/",
  ADMIN_STATUS: "admin/status/",
  ADMIN_SEARCH: "admin/admin-search/",
  ADMIN: 'admin/admin/',
  ADMINS: 'admin/',
  ROLES_LIST: 'admin/role/',
  ROLES_ADD_LIST: 'admin/router/permissions/',
  ROLES_POST_LIST: 'admin/route/',
  ROLES_ADD_GET: 'admin/router/roles/',
  // VEHICLE MASTER
  VEHICLE_LIST: "admin/vehicle-type/list/",
  VEHICLE_LIST_TYPE: "admin/vehicle-type/true-list/",
  VEHICLE_TRIP_LIST: "admin/vehicle-history/",
  DRIVER_TRIP_LIST: "admin/driver-history/",
  VEHICLE_SEARCH: "admin/vehicle-type/search/",
  VEHICLE_ADD: "admin/vehicle-type/create/",
  VEHICLE_EDIT: "admin/vehicle-type/update/",
  VEHICLE_STATUS: "admin/vehicle-type/update-status/",
  // USER MANAGEMENT
  USER_MANAGEMENT_LIST: "user/list/",
  USER_MANAGEMENT_STATUS: "user/status/update/",
  // 
  // USER_MANAGEMENT_STATUS: "admin/user/status/",
  USER_DETAILS_VIEW: "user/details/",
  USER_VIEW_POST: "admin/user/post/?user_id=",
  USER_VIEW_ENQUIRIES: "admin/user/enquiries/?user_id=",
  USER_VIEW_BOOKINGS: "admin/user/bookings/?user_id=",
  USER_VIEW_PROMOTION: "admin/user/promotions/?user_id=",
  USER_VIEW_DETATILS: "admin/user/details/?user_id=",
  POST_MANAGEMENT_LIST: "/admin/posts/",
  POST_STATUS: "admin/posts/",
  USER_SPECIALUSER: '/user/special_user/update/',
  USER_PASTTRIPS: 'admin/user-booking-history/',
  // MASTERS LIST
  CATEGORIES_LIST: "admin/categories/list/",
  CATEGORIES_STATUS: "admin/categories/",
  CATEGORIES_ADD: "admin/categories/create/",
  CATEGORIES_EDIT: "admin/categories/",
  // TRANSPORT MANAGEMENT
  TRANSPORT_LIST: "admin/transport/list/",
  TRANSPORT_ADD: "admin/transport/onboarding/",
  TRANSPORT_VIEW: 'admin/transport-details/list/',
  VEHICLE_TRANSPORT_LIST: "admin/vehicle/list/",
  VEHICLE_TRANSPORT_STATUS: "admin/vehicle-status-update/",
  VEHICLE_TRANSPORT_ADD: 'admin/vehicle/create/',
  VEHICLE_TRANSPORT_EDIT: 'admin/vehicle/update/',
  VEHICLE_TRANSPORT_DRIVER_LIST: 'admin/driver/list/',
  VEHICLE_TRANSPORT_BOOKINGS_LIST: 'admin/bookings/',
  TRANSPORT_DRIVER_STATUS: 'admin/driver-status-update/',
  VEHICLE_DRIVER_ADD: 'admin/driver/create/',
  VEHICLE_DRIVER_EDIT: 'admin/driver/update/',

  // BOOKINGS
  BOOKINGS_LIST: "admin/bookings/list/",
  BOOKINGS_CANCEL: 'admin/bookings/cancel/',
  BOOKINGS_TRIP_DATE: "admin/booking/trip-end-create/",
  BOOKINGS_CANCEL_VEHICLE: 'admin/booking/cancel-vehicle/',

  // TRANSACTIONS
  USER_TRANSACTIONS_LIST: 'admin/admin/transactions/user-transaction-list/',
  TRANSPORT_TRANSACTIONS_LIST: 'admin/transport/pending-payment-list/',
  TRANSPORT_COMPLETED_LIST: 'admin/transport/completed-payment-list/',
  TRANSPORT_PENDING_VIEW: 'admin/transport/pending-booking-list/',
  TRANSPORT_PAYMENT: 'admin/transport/create-payment/',
  TRANSPORT_COMPLETED_PAYMENT: 'admin/transport/Completed-booking-list/',
  // PUSH NOTIFICATION
  PUSH_NOTIFICATION_LIST: 'admin/notifications_list/',
  PUSH_NOTIFICATION_ADD: 'admin/push-notifications/',
  PUSH_NOTIFICATION_DRIVER_LIST: 'admin/pushnotification/driver/list/',
  PUSH_NOTIFICATION_TRANSPORT_LIST: 'admin/pushnotification/transport/list/',
  //FAQ
  FAQ_LIST: 'admin/faq/list/',
  FAQ_STATUS: 'admin/faq/status-update/',
  FAQ_ADD: 'admin/faq/create/',
  FAQ_EDIT: 'admin/faq/update/',
  FAQ_DELETE: 'admin/faq/delete/',
  //CONTACTS
  CONTACTS_LIST: "admin/contact/list/",
  CONTACTS_ADD: "admin/contact/create/",
  CONTACTS__EDIT: "admin/contact/update/",
  CONTACTS_DELETE: "admin/contact/delete/",
  // HELP&SUPPORT
  HELP_LIST: "admin/support/list/",
  HELP_RESOLVED: 'admin/support/status-update/',


  REQUEST_ASSIGN_TRANSPORT: 'admin/api/transports/dropdown/',
  REQUEST_VEHICLE_SELECT: 'admin/booking/vehicle-types/',
  REQUEST_VEHICLE_NUMBER: 'admin/api/vehicles/',
  REQUEST_DRIVERS: 'admin/api/drivers/',
  REQUEST_BOOKING_CONFIRM: 'admin/booking/confirm-trip/',
  ASSIGN_CONFIRM: 'admin/booking/edit-assign/',

  DASHBOARD: 'admin/admin/dashboard/'
};

export const TOKEN = "token";
export const LOGGEDUSER = "loggeduser";
export const USER_DETAILS = "user_details";
export const PROFILE = "profile";
export const LOCATION = "userlocation";
export const LOCATIONNAME = "locationname";

export const NUMBER = /^\+?(0|[6-9]\d*)$/;

export const EMAIL =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PASS =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*.?&])[A-Za-z\d@$!%.*?&]{8,}$/;
export const isValidEmail = (email) => {
  return EMAIL.test(email);
};

export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const productDetailImg = {
  loop: true,
  autoplay: false,
  center: true,
  dots: true,
  autoplayTimeout: 3000,
  smartSpeed: 450,
  nav: false,
  responsive: {
    0: {
      items: 1,
    },
  },
};

//Refer at https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_expressions
export const formatKey = (key) => {
  return key
    .replace(/_/g, " ") // underscores to spaces
    .replace(/([a-z])([A-Z])/g, "$1 $2") // camelCase too split
    .replace(/\s+/g, " ") // simple spaces
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase()); // capital words
};
